var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    stroke: "#545454",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 22h10m-5-4v4M3 2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z",
    stroke: "{stroke}",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.974 12.16a.9.9 0 0 1 .062-.524.899.899 0 0 1 .824-.545h.05a1.09 1.09 0 1 0 0-2.182h-.094a.9.9 0 0 1-.823-.545V8.32a.9.9 0 0 1 .18-.993l.033-.032a1.091 1.091 0 1 0-1.544-1.544l-.033.033a.9.9 0 0 1-.993.18.9.9 0 0 1-.545-.824v-.05a1.09 1.09 0 1 0-2.182 0v.094a.9.9 0 0 1-.545.823h-.044a.9.9 0 0 1-.993-.18l-.032-.032A1.091 1.091 0 1 0 7.75 7.338l.033.033a.9.9 0 0 1 .18.993.9.9 0 0 1-.824.589h-.05a1.09 1.09 0 1 0 0 2.181h.094a.9.9 0 0 1 .823.546.9.9 0 0 1-.18.993l-.032.033a1.09 1.09 0 1 0 1.543 1.543l.033-.033a.9.9 0 0 1 .993-.18.9.9 0 0 1 .589.824v.05a1.091 1.091 0 0 0 2.181 0v-.094a.9.9 0 0 1 .546-.823.9.9 0 0 1 .993.18l.033.033a1.091 1.091 0 1 0 1.543-1.544l-.033-.033a.9.9 0 0 1-.242-.469zm-2.345-2.159a1.636 1.636 0 1 1-3.273 0 1.636 1.636 0 0 1 3.273 0z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/system.28f5a6a467029d393dd6b7c189a1cd86.svg";
export { ForwardRef as ReactComponent };